<template>
  <div>
    <entri-details :entriId="entriId" />
    <vx-card id="loading-entri-card" class="vs-con-loading__container">
      <card-header
        :title="$t('pallets_in_warehouse_by_client')"
        v-model="params.search"
        @search="search"
        @close="close"
      />
      <entri-table
        :data="items"
        @loadMore="loadMore"
        @showDetails="showDetails"
        @search="search"
      />
    </vx-card>
  </div>
</template>

<script>
import EntriTable from '../tables/EntryTable.vue'
import EntriDetails from '../sidebards/EntryDetails.vue'
import dashboard from '@/http/requests/dashboard'
import CardHeader from '../components/CardHeader.vue'

export default {
  name: 'entri-card',
  components: {
    EntriTable,
    CardHeader,
    EntriDetails,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      cardTitle: 'Titulo',
      cardId: 'loading-entri-card',
      items: [],
      entriId: '',
      lastPage: 1,
      loading: false,
      params: {
        page: 1,
        search: '',
        ClientName: 'ALDILA GOLF CORPORATION',
      },
    }
  },
  methods: {
    getData() {
      this.loading = true
      this.params.ClientName = this.data.ClientName
      if (this.params.ClientName != null) {
        dashboard
          .EntriDataTable(this.params)
          .then((response) => {
            if (this.params.page === 1) {
              this.items = [...response.data.result.data]
            } else {
              this.items = [...this.items, ...response.data.result.data]
            }
            this.lastPage = response.data.result.last_page
            this.loading = false
          })
          .catch((response) => {
            this.showValidationErrors(response)
            this.loading = false
          })
      } else {
        dashboard
          .fullEntriDataTable(this.params)
          .then((response) => {
            if (this.params.page === 1) {
              this.items = [...response.data.result.data]
            } else {
              this.items = [...this.items, ...response.data.result.data]
            }
            this.lastPage = response.data.result.last_page
            this.loading = false
          })
          .catch((response) => {
            this.showValidationErrors(response)
            this.loading = false
          })
      }
    },
    loadMore() {
      if (this.params.page >= this.lastPage) {
        return
      }
      this.params.page++
      this.getData()
    },
    search() {
      this.params.page = 1
      this.getData()
    },
    close() {
      this.$emit('close')
    },
    showDetails(e) {
      this.entriId = e
      this.$store.dispatch('toggleSidebar', 'sidebar-entri-details')
    },
  },
  mounted() {
    this.search()
  },
  watch: {
    loading(val) {
      if (val) {
        this.$vs.loading({
          container: `#${this.cardId}`,
          scale: 0.45,
        })
      } else {
        this.$vs.loading.close(`#${this.cardId} > .con-vs-loading`)
      }
    },
    data() {
      this.search()
    },
  },
}
</script>

